import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/icons/icon-arrow-right.svg")